import { Model } from '@vuex-orm/core'
import { v4 as uuid } from 'uuid'
import marked from 'marked'
import insane from 'insane' // NOTE sanitization should be server side

import parser from '@/utils/notification-parser'
import i18n from '@/plugins/i18n'
import { INSANE_CONFIG } from '@/utils/constants'

class Notification extends Model {
  static entity = 'notifications'

  static fields() {
    return {
      id: this.uid(() => uuid()),
      type: this.string(''),
      data: this.attr(null).nullable(),
      timestamp: this.attr(Date.now),
      unread: this.boolean(true),
      persistent: this.boolean(false),
      action: this.attr(null).nullable(),
    }
  }

  get title() {
    return i18n.t(`notification.${this.type}.title`)
  }

  get text() {
    return i18n.t(`notification.${this.type}.text`, this.parsedData)
  }

  get toastText() {
    return i18n.t(`notification.${this.type}.toast`, this.parsedData)
  }

  get parsedData() {
    if (!this.type) return {}
    return parser[this.type]?.(this.data, this) ?? this.data ?? {}
  }

  get content() {
    return marked(insane(this.text, INSANE_CONFIG))
  }

  get toastContent() {
    return marked(insane(this.toastText, INSANE_CONFIG))
  }
}

export default Notification

export const store = {
  actions: {
    async create({ dispatch, commit, rootGetters }, data) {
      const { _vm: vm } = this
      const { userActive } = rootGetters
      /**
       * TODO Chrome notif
       */

      const { notifications: [notif] } = await Notification.insertOrUpdate({ data })

      if (data.expiration) {
        console.log(data.expiration)
        setTimeout(notif.$delete.bind(notif), data.expiration)
      }

      // if we dont want toasts, we done
      if (data.silent) return

      const settings = rootGetters['settings/settings']

      vm.$toast.info(notif.toastContent, {
        title: notif.title,
        notificationId: notif.id,
        volume: settings.sounds.volumes.notifications,
        options: {
          action: data.action ?? null,
        },
      })

      if (!userActive) {
        // browser notif
      }
    },
  },
}
